import * as yup from 'yup'
import moment from 'moment'

const defaultRequiredMessage = 'Este campo é obrigatório'

yup.setLocale({
  mixed: {
    required: defaultRequiredMessage
  }
})

const validateDate = date => {
  const today = moment().startOf('day')
  const birthDate = moment(date, 'DD/MM/YYYY').startOf('day')
  return birthDate.isValid() && birthDate.isSameOrBefore(today)
}

export const validationSchema = yup.object().shape({
  name: yup.string().trim().required(),
  gender: yup.string().trim().required(),
  weight: yup.string().trim().nullable(),
  castrated: yup.boolean(),
  birth: yup.string().trim().nullable().test(
    'data-future',
    'Digite uma data válida',
    function (date) {
      if (!date) return true // Se não houver valor, considere válido
      return validateDate(date)
    }
  ),
  specie: yup.string().trim().required(),
  breed: yup.string().trim().required(),
  temperament: yup.string().trim().nullable().required(),
  pedigree: yup.boolean()
})
